import { render } from "./SkeletonAdditionalNews.vue?vue&type=template&id=07b3e5ea&scoped=true"
import script from "./SkeletonAdditionalNews.vue?vue&type=script&lang=js"
export * from "./SkeletonAdditionalNews.vue?vue&type=script&lang=js"

import "./SkeletonAdditionalNews.vue?vue&type=style&index=0&id=07b3e5ea&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07b3e5ea"]])

export default __exports__